import { Dispatch, SetStateAction } from 'react'
import { IconButton } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import { MenuOpen } from '@mui/icons-material'

export type MenuOpenState = [boolean, Dispatch<SetStateAction<boolean>>]
interface MenuOpenButtonProps {
  /** The current state of the menu and a function to set that state. */
  menuOpenState?: MenuOpenState
}

/**
 * `MenuOpenButton` is a component that renders a button which toggles a menu open or closed.
 * @param props - The properties that define the `MenuOpenButton` component.
 * @category General Layout
 */
export default function MenuOpenButton(
  props: MenuOpenButtonProps
): JSX.Element {
  const { menuOpenState } = props
  if (!menuOpenState) return <></>
  const [open, setOpen] = menuOpenState
  return (
    <IconButton
      size='large'
      edge='start'
      color='inherit'
      aria-label='menu'
      sx={{ mr: 2 }}
      onClick={() => setOpen(!open)}
    >
      {open ? (
        <MenuOpen aria-label='menu opened' />
      ) : (
        <MenuIcon aria-label='menu closed' />
      )}
    </IconButton>
  )
}
